import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

// Services
import { ServiceBase } from '../service-base';

// Modèles
import { GeneralFactory } from 'src/app/@shared/models/factories/general-factory';
import { ClientUserNotificationSetting } from 'src/app/@shared/models/notifications/client-user-notification-setting.model';
import { UserNotificationSetting } from 'src/app/@shared/models/notifications/user-notification-setting.model';

const CLASS_NAME = 'UserNotificationSetting';
const ENDPOINT = '/user-notification-settings/';
const CLIENT_ENDPOINT = '/client-user-notification-settings/';

@Injectable({
    providedIn: 'root'
})
export class NotificationSettingsService extends ServiceBase {

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }

    /**
     * Sauvegarde une préférence de notification utilisateur.
     * Utilise PUT direct (pas ODataResponse) car l'API retourne l'objet brut.
     */
    saveUserSetting$(instance: UserNotificationSetting): Observable<UserNotificationSetting | null> {
        const url = this.routes.update.replace('{id}', instance.id.toString());
        this._updating$.next(true);
        instance.busy = true;

        return this.httpClient.put<any>(url, {
            pushEnabled: instance.pushEnabled,
            emailEnabled: instance.emailEnabled,
        }).pipe(
            finalize(() => {
                instance.busy = false;
                this._updating$.next(false);
            }),
            map(body => GeneralFactory.get('UserNotificationSetting', body) as UserNotificationSetting),
            catchError(error => {
                this.handleError(error);
                return of(null);
            })
        );
    }

    /**
     * Liste les préférences de notification dans le contexte du client courant.
     * Le header Context-Client est ajouté automatiquement par l'intercepteur.
     */
    listClientSettings$(): Observable<ClientUserNotificationSetting[]> {
        this._fetching$.next(true);

        return this.httpClient.get<any[]>(CLIENT_ENDPOINT).pipe(
            finalize(() => this._fetching$.next(false)),
            map(results => results.map(
                r => GeneralFactory.get('ClientUserNotificationSetting', r) as ClientUserNotificationSetting
            )),
            catchError(error => {
                this.handleError(error);
                return of([]);
            })
        );
    }

    /**
     * Sauvegarde une préférence de notification dans le contexte du client courant.
     * Le header Context-Client est ajouté automatiquement par l'intercepteur.
     */
    saveClientSetting$(instance: ClientUserNotificationSetting): Observable<ClientUserNotificationSetting | null> {
        const url = `${CLIENT_ENDPOINT}${instance.id}/`;
        this._updating$.next(true);
        instance.busy = true;

        return this.httpClient.put<any>(url, {
            pushEnabled: instance.pushEnabled,
            emailEnabled: instance.emailEnabled,
        }).pipe(
            finalize(() => {
                instance.busy = false;
                this._updating$.next(false);
            }),
            map(body => GeneralFactory.get('ClientUserNotificationSetting', body) as ClientUserNotificationSetting),
            catchError(error => {
                this.handleError(error);
                return of(null);
            })
        );
    }

}
